/*                                                    */
const BACKGROUND_FADE_DISTANCE = 80; /**/
/*                                                                                */
const BACKGROUND_FADE_START_OFFSET = 30; /**/

export class Stage {
    private readonly backgroundModule: HTMLElement | null
    private readonly stageContent: HTMLElement | null
    private readonly stageBackground: HTMLElement | null
    private readonly headline: HTMLElement | null
    private readonly mobileSizeMediaQuery: MediaQueryList;

    constructor() {
        this.backgroundModule = document.querySelector(".promo-module-background");
        this.stageBackground = document.querySelector(".promo_staticcontent--stage-widget-image");
        this.headline = document.querySelector(".promo_staticcontent--stage-widget-headline");
        this.stageContent = document.getElementById("promo_stage-content");
        this.mobileSizeMediaQuery = window.matchMedia("(width < 48em)");
        if (this.mobileSizeMediaQuery.matches) {
            this.splitModuleIntoBackgroundAndContent()
            this.setHeadlineTopMargin()
        }
        /*                                                      */
        /*                       */
    }

    private splitModuleIntoBackgroundAndContent(): void {
        if (this.backgroundModule) {
            /*                                                                         */
            const contentContainer = document.createElement("div");
            contentContainer.classList.add("promo-module-foreground");
            this.backgroundModule.parentNode?.insertBefore(contentContainer, this.backgroundModule.nextSibling);

            /*                                                                       */
            if (this.stageContent) {
                const contentNode = this.stageContent.cloneNode(true)
                contentContainer.appendChild(contentNode);
                this.stageContent.remove()
                /*                                      */
                this.addScrollListener(contentNode as HTMLElement);
            }
        }
    }

    private addScrollListener(contentNode: HTMLElement): void {

        let initialYPos = 0;
        const headlineElement = document.querySelector(".promo_staticcontent--stage-widget-headline");

        window.addEventListener("scroll", () => {

            if (this.stageBackground) {
                /*                                                                                                                */
                if (initialYPos == 0 && this.stageBackground.getBoundingClientRect().top <= 0) {
                    initialYPos = contentNode.getBoundingClientRect().y || 0;
                }

                /*                                                                */
                const yPos = contentNode.getBoundingClientRect().y || 0;
                const differencePx = initialYPos - Math.max(0, yPos);
                const scale = Math.max(1, 1 + (differencePx / initialYPos / 2)); /*                                   */
                /*                                                                                    */

                /*                                               */
                this.stageBackground.style.transform = `scale(${scale})`;

                /*                                                                                                      */
                const topOfHeadline = headlineElement?.getBoundingClientRect().top || 0;
                const topDifferencePx = Math.max(Math.min(BACKGROUND_FADE_DISTANCE, topOfHeadline - BACKGROUND_FADE_START_OFFSET), 0);

                const calculatedFade = 1 - (topDifferencePx / BACKGROUND_FADE_DISTANCE);
                const calculatedOpacity = 1 - calculatedFade;

                /*                             */
                /*                                                                                                                                                                                                                                      */

                /*                                                                                                */
                document.documentElement.style.setProperty("--promo-aggregation-topic-page-two-gradient-opacity", `${calculatedFade.toFixed(2)}`);
                this.stageBackground.style.opacity = calculatedOpacity.toFixed(2);
            }

        }, {passive: true});
    }

    private setHeadlineTopMargin() {
        if (this.headline) {
            this.headline.style.marginTop = (0 - this.headline.clientHeight) + "px";
        }
    }


    /*                            */
    /*                                                                                    */
    /*                      */
    /*                                                                              */
    /*                                                */
    /*                                       */
    /*                                                          */
    /*                                                                      */
    /**/
}